import { useCallback } from "react";
import { formattedDate } from "../../../utils/date";
export var useRolOptionsMenu = function (_a) {
    var setIsEdit = _a.setIsEdit, setRolId = _a.setRolId, setOpenModalCreate = _a.setOpenModalCreate, setDataFormRoles = _a.setDataFormRoles, setRolName = _a.setRolName, setRolDescription = _a.setRolDescription, setPermissionsRows = _a.setPermissionsRows, setAssignedPermissions = _a.setAssignedPermissions, setOpenDrawer = _a.setOpenDrawer;
    /**
     * Maneja la opción de editar rol (nombre y descripción)
     */
    var handleEditRol = useCallback(function (item) {
        var _a;
        setIsEdit(true);
        setRolId(item.id);
        setOpenModalCreate(true);
        // Extraer IDs de permisos asignados
        var permissionIds = ((_a = item.permissions) === null || _a === void 0 ? void 0 : _a.map(function (p) { var _a; return (_a = p === null || p === void 0 ? void 0 : p.id) !== null && _a !== void 0 ? _a : ""; })) || [];
        setDataFormRoles({
            name: item.code,
            description: item.description,
            permissions: permissionIds,
        });
    }, [setIsEdit, setRolId, setOpenModalCreate, setDataFormRoles]);
    /**
     * Maneja la opción de editar permisos del rol
     */
    var handleEditPermissions = useCallback(function (item) {
        var _a, _b;
        setRolName(item.code);
        setRolId(item.id);
        setRolDescription(item.description);
        // Mapear permisos para la tabla
        var rows = ((_a = item.permissions) === null || _a === void 0 ? void 0 : _a.map(function (p) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return ({
                id: (_a = p === null || p === void 0 ? void 0 : p.id) !== null && _a !== void 0 ? _a : "",
                name: (_b = p.name) !== null && _b !== void 0 ? _b : "",
                description: (_c = p.description) !== null && _c !== void 0 ? _c : "",
                type: (_d = p.type) !== null && _d !== void 0 ? _d : "",
                enabled: String(p.enabled).toLowerCase() === "true"
                    ? "Habilitado"
                    : "Deshabilitado",
                createdAt: formattedDate((_e = p.createdAt) !== null && _e !== void 0 ? _e : ""),
                refName: (_f = p.refName) !== null && _f !== void 0 ? _f : "",
                disabledReason: (_g = p.disabledReason) !== null && _g !== void 0 ? _g : "",
                deletedReason: (_h = p.deletedReason) !== null && _h !== void 0 ? _h : "",
            });
        })) || [];
        setPermissionsRows(rows);
        // Mapear permisos para asignación (DragDrop)
        var permissionsList = ((_b = item.permissions) === null || _b === void 0 ? void 0 : _b.map(function (p) {
            var _a, _b, _c, _d;
            return ({
                id: (_a = p === null || p === void 0 ? void 0 : p.id) !== null && _a !== void 0 ? _a : "",
                name: (_b = p.name) !== null && _b !== void 0 ? _b : "",
                description: (_c = p.description) !== null && _c !== void 0 ? _c : "",
                type: (_d = p.type) !== null && _d !== void 0 ? _d : "",
            });
        })) || [];
        setAssignedPermissions(permissionsList);
        setOpenDrawer(true);
    }, [
        setRolName,
        setRolId,
        setRolDescription,
        setPermissionsRows,
        setAssignedPermissions,
        setOpenDrawer,
    ]);
    /**
     * Maneja el click en las opciones del menú contextual
     */
    var onOptionsCardClick = useCallback(function (opt, item) {
        switch (opt.id) {
            case "1": // Editar rol
                handleEditRol(item);
                break;
            case "2": // Editar permisos
                handleEditPermissions(item);
                break;
            default:
                console.warn("Opci\u00F3n no manejada: ".concat(opt.id));
        }
    }, [handleEditRol, handleEditPermissions]);
    return {
        onOptionsCardClick: onOptionsCardClick,
        handleEditRol: handleEditRol,
        handleEditPermissions: handleEditPermissions,
    };
};
